import { render, staticRenderFns } from "./ivr-wage-plan.vue?vue&type=template&id=fe3c2de0&scoped=true"
import script from "./ivr-wage-plan.vue?vue&type=script&lang=js"
export * from "./ivr-wage-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c2de0",
  null
  
)

export default component.exports